import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { WeakCache } from "../../../../../stream";
import { iText } from "../state/Text";
import { iStategroup } from "../state/Stategroup";
import { iCollection } from "../state/Collection";
import update = require("../widgets/instructions/update");
import ClientStateObjectProxy from "./ClientStateObjectProxy";

export function isSaving(node: api_cs.Cnode): boolean {
	switch (node.properties.is_busy_saving.state.name) {
		case "yes":
			return true;
		case "no": {
			const parent = node.input.position().input.parent();
			switch (parent.variant.name) {
				case "node":
					return isSaving(parent.variant.definition);
				case "none":
					return false;
				default:
					unexpectedState(parent.variant);
			}
			break;
		}
		default:
			unexpectedState(node.properties.is_busy_saving.state);
	}
}

export function parent(node: api_cs.Cnode): api_cs.Cnode | undefined {
	const parent = node.input.position().input.parent();
	switch (parent.variant.name) {
		case "node":
			return parent.variant.definition;
		case "none":
			return undefined;
		default:
			unexpectedState(parent.variant);
	}
}

class NodeInterface extends ClientStateObjectProxy {
	constructor(readonly node: api_cs.Cnode) {
		super();
	}

	discard() {
		for (const attribute of this.node.properties.attributes.values()) {
			attribute.properties.type.switch({
				operation: undefined,
				property: (property) => {
					property.properties.type.switch({
						file: (file) => {
							file.properties.is_editable.switch({
								no: undefined,
								yes: (is_editable) => {
									this.node.properties.location.switch({
										remote: () => {
											file.properties.backend_known.switch({
												no: undefined,
												yes: ($) => {
													$.properties.is_readable.switch({
														no: undefined,
														yes: ($) => {
															is_editable.properties.modified.set("no", {});
															file.properties.is_set.set("yes", {
																token: $.properties.token,
																extension: $.properties.extension,
															});
														},
													});
												},
											});
										},
										local: () => {
											is_editable.properties.modified.set("no", {});
											file.properties.is_set.set("no", {});
										},
									});
								},
							});
						},
						text: (text) => {
							iText(text).discard();
						},
						number: (number_property) => {
							number_property.properties.is_editable.switch({
								no: undefined,
								yes: () => {
									this.node.properties.location.switch({
										remote: () => {
											update.number_toBackendValue(number_property);
										},
										local: () => {
											number_property.properties.is_editable.switch({
												no: undefined,
												yes: ($) => {
													$.properties.modified.set("no", {});
													number_property.properties.is_set.set("no", {});
												},
											});
										},
									});
								},
							});
						},
						"state group": (state_group) => {
							iStategroup(state_group).discard();
						},
						collection: (collection) => {
							iCollection(collection).discard();
						},
						group: (group) => {
							iNode(group.properties.node).discard();
						},
					});
				},
			});
		}
	}
}

export type iNode = NodeInterface;
export const iNode = WeakCache<api_cs.Cnode, NodeInterface>((s) => new NodeInterface(s));
